import { act, ComponentType, ReactElement } from 'react';
import { InterActive } from '../../utilities/ViewModelStructure'
import { JsxElement } from 'typescript';
import ClientsWithRemainingMoney from '../../../Component/Admin/ClientsWithRemainingMoney';
export class PerformanceReportsVM extends InterActive{
    
    private element : JSX.Element = <ClientsWithRemainingMoney/> ;

    public get Element():JSX.Element{
        return this.element;
    }
    public setContent(V : React.ComponentType , active:number) {
        this.element = <V/>; this.active=active; this.update()
    }

    private active:number=0
    public get Active():number{return this.active}
    public set Active(value:number){this.active = value; this.update()}
    
}